module.exports = __webpack_public_path__ + "img/todo-close.9c7b57ac.svg";